@for (exercise of exercises(); track exercise.exercise.id) {
  <lyceo-exercise-card
    [results]="exercise.results"
    [loading]="loading()"
    [mainTitle]="
      exercise.exercise.exerciseType === 'NORMAL'
        ? 'Test je kennis'
        : 'Bonusopgaven'
    "
    [text]="
      exercise.exercise.exerciseType === 'NORMAL'
        ? 'Haal een voldoende om deze les af te ronden.'
        : 'Kun je nog wat extra hulp gebruiken?'
    "
    [buttonText]="
      exercise.exercise.exerciseType === 'NORMAL'
        ? 'Oefenopgaven'
        : 'Bonusopgaven'
    "
    [exerciseType]="
      exercise.exercise.exerciseType === 'NORMAL' ? 'NORMAL' : 'BONUS'
    "
    (buttonClick)="exerciseClicked.emit(exercise.exercise)"
    (viewResults)="viewResultsClicked.emit($event)"
  />
}
